export default __webpack_public_path__ + "static/media/bankist.c8966cc8.png";